import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { formatRut, RutFormat } from '@fdograph/rut-utilities';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Validators } from 'ngx-editor';
import { ToastrService } from 'ngx-toastr';
import { MyValidators } from 'src/app/libs/my-validators';
import { ApiService } from 'src/app/services/api.service';
import { ApiEntryControlService } from '../../../api-entry-control.service';
import { Visitors } from '../../../interfaces/visitors';
import { Suggestion, SuggestionInputComponent } from 'src/app/components/suggestion-input/suggestion-input.component';
import { Cars } from '../../../interfaces/cars';
import { Features } from '../../../interfaces/features';
import { Drivers } from '../../../interfaces/drivers';

@Component({
  selector: 'app-edit-car',
  templateUrl: './edit-car.component.html',
  styleUrl: './edit-car.component.css'
})
export class EditCarComponent implements OnInit, OnChanges {
  constructor(
    private api: ApiEntryControlService,
    private apiFull: ApiService,
    private formBuilder: FormBuilder,
    private toast: ToastrService,
  ) { }
  ngOnInit(): void {
    console.log("Llego a edit cars");
    this.getState();
    if (this.car != null) {
      this.get(this.car);
      this.api.getAllFeaturesFilter(1).subscribe((response) => {
        var suggestion: Suggestion[] = SuggestionInputComponent.convertJsonASuggestion(response.data as Features[], ['tag']);
        this.types = suggestion;
      }, e => {
        this.toast.warning(e.error.mistakes, e.error.msg);
      });
      this.api.getAllFeaturesFilter(2).subscribe((response) => {
        var suggestion: Suggestion[] = SuggestionInputComponent.convertJsonASuggestion(response.data as Features[], ['tag']);
        this.brands = suggestion;
      }, e => {
        this.toast.warning(e.error.mistakes, e.error.msg);
      });

      this.api.getAllDriverStore(this.storesId).subscribe((response) => {
        var suggestion: Suggestion[] = SuggestionInputComponent.convertJsonASuggestion(response.data as Drivers[], ['name', 'lastname']);
        this.drivers = suggestion;
      });

    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("Llego a edit cars change");
    if (changes['cars']?.currentValue != this.car) {
      this.get(this.car);
    }
  }
  types: Suggestion[];
  brands: Suggestion[];
  drivers: Suggestion[];

  @Output()
  success = new EventEmitter<boolean>();
  @Input()
  car: Cars;
  items: any;


  @Input()
  storesId: number;
  form1: FormGroup = this.formBuilder.group({
    id: [],
    ppu: ['', Validators.required],
    type: ['', [Validators.required]],
    types_id: [134],
    brand: [''],
    brands_id: [0],
    model: [''],
    obs: [''],
    parking: [0],
    state_id: [1],
    stores_id: [0],
  });
  driverForm: FormGroup = this.formBuilder.group({
    id: [],
    name: ['', Validators.required],
  });
  get(item: Cars) {
    if (this.car?.id > 0) {
      this.api.getCar(item?.id).subscribe((res) => {
        this.form1.patchValue(res.data);
      }, error => {
        this.toast.warning(error.error.mistakes, error.error.msg, { enableHtml: true, closeButton: true });
      });
    }
  }
  getState() {
    this.apiFull.getState().subscribe((res) => {
      this.items = res.data;
    });
  }

  onFormatRut(value: any) {
    if (value.target.value.length > 8) {
      this.form1
        .get('rut')
        ?.setValue(formatRut(value.target.value, RutFormat.DOTS_DASH));
    }
  }
  update() {
    this.api.updateCars(this.form1).subscribe(
      (response) => {
        this.toast.success(response.msg, 'Vehículos');
        this.success.emit(true);
      },
      (err) => {
        this.toast.warning(err.error.mistakes, err.error.msg, { enableHtml: true, closeButton: true });
      }
    );
  }

}
